import { PlusCircleIcon } from '@phosphor-icons/react';

interface ToggleInputFeaturesButtonProps {
    handlePlusClick: any;
    handleCrossClick: any;
    showIcons: boolean;
    messageLength: number;
}

export default function ToggleInputFeaturesButton({
    handlePlusClick,
    handleCrossClick,
    showIcons,
    messageLength,
}: ToggleInputFeaturesButtonProps) {
    return (
        <div
            style={{
                minWidth: (messageLength <= 0 ? '0' : '40') + 'px',
            }}
            className={` relative flex items-center justify-center pl-0 min-w-[40px] h-[60px] transition-colors duration-100 hover:text-primary `}
        >
            {messageLength !== 0 && (
                <button
                    onClick={!showIcons ? handlePlusClick : handleCrossClick}
                    className={`text-chatInput-inlineButtonColor transition-100 duration-100 ${
                        showIcons ? 'rotate-45 text-primary' : 'rotate-0'
                    }`}
                >
                    <PlusCircleIcon size={24} />
                </button>
            )}
        </div>
    );
}
